export const ScoreBase = (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="0 0 34 22" fill="none">
        <path
            d="M18.0665 8.49665V1C22.0974 1.26622 25.8773 3.05152 28.6433 5.99564L23.1699 10.6244C21.3317 9.32297 20.2155 8.79294 18.0665 8.49665Z"
            fill="#B3BAD1"
        />
        <path
            d="M30 7.64236C32.1835 10.6746 33.2304 14.3784 32.9574 18.105C32.9383 18.374 32.818 18.6258 32.6207 18.8096C32.4234 18.9934 32.1638 19.0957 31.8941 19.0958H26.5401C26.3902 19.0959 26.2419 19.0642 26.105 19.0031C25.9681 18.9419 25.8456 18.8525 25.7455 18.7408C25.6455 18.6291 25.5701 18.4975 25.5244 18.3547C25.4786 18.2119 25.4635 18.0611 25.48 17.912C25.6537 14.8083 25.1693 13.8102 24.1601 12.2402L30 7.64236Z"
            fill="#B3BAD1"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9335 1C11.9026 1.26622 8.12273 3.05152 5.35667 5.99564L11.2909 10.6244C12.5839 9.45627 14.2045 8.71353 15.9335 8.49665V1Z"
            fill="#B3BAD1"
        />
        <path
            d="M9.89476 12.2402C8.78066 13.9089 8.29361 15.9183 8.52 17.912C8.5365 18.0611 8.52138 18.2119 8.47562 18.3547C8.42987 18.4975 8.35451 18.6291 8.25447 18.7408C8.15443 18.8525 8.03195 18.9419 7.89503 19.0031C7.75812 19.0642 7.60984 19.0959 7.45987 19.0958H2.10588C1.83622 19.0957 1.57661 18.9934 1.37932 18.8096C1.18203 18.6258 1.0617 18.374 1.04255 18.105C0.769559 14.3784 1.81653 10.6746 4.00004 7.64236L9.89476 12.2402Z"
            fill="#001965"
        />
        <path
            d="M13.371 19.4118C10.7771 18.2024 7.58503 16.2541 7.58503 16.2541C7.42843 16.1594 7.30065 16.0236 7.21547 15.8616C7.13029 15.6996 7.09094 15.5174 7.10165 15.3347C7.11235 15.1519 7.17271 14.9756 7.27623 14.8246C7.37975 14.6736 7.5225 14.5538 7.68909 14.4779C7.68909 14.4779 11.0878 12.9161 13.8046 12.0183C15.1021 11.5896 16.2677 11.3286 16.9289 11.3668C18.1297 11.4381 19.2531 11.9831 20.0524 12.8819C20.8517 13.7808 21.2616 14.9602 21.1921 16.1611C21.1209 17.3619 20.5758 18.4853 19.6768 19.2845C18.7777 20.0837 17.5982 20.4934 16.3973 20.4234C15.7368 20.3847 14.6102 19.9888 13.371 19.4118Z"
            fill="#001965"
            stroke="white"
            stroke-width="2"
        />
    </svg>
);

export const ScoreBuilding = (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="0 0 34 22" fill="none">
        <path
            d="M18.0665 8.49665V1C22.0974 1.26622 25.8773 3.05152 28.6433 5.99564L23.1699 10.6244C21.3317 9.32297 20.2155 8.79294 18.0665 8.49665Z"
            fill="#B3BAD1"
        />
        <path
            d="M30 7.64236C32.1835 10.6746 33.2304 14.3784 32.9574 18.105C32.9383 18.374 32.818 18.6258 32.6207 18.8096C32.4234 18.9934 32.1638 19.0957 31.8941 19.0958H26.5401C26.3902 19.0959 26.2419 19.0642 26.105 19.0031C25.9681 18.9419 25.8456 18.8525 25.7455 18.7408C25.6455 18.6291 25.5701 18.4975 25.5244 18.3547C25.4786 18.2119 25.4635 18.0611 25.48 17.912C25.6537 14.8083 25.1693 13.8102 24.1601 12.2402L30 7.64236Z"
            fill="#B3BAD1"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9335 1C11.9026 1.26622 8.12273 3.05152 5.35667 5.99564L11.2909 10.6244C12.5839 9.45627 14.2045 8.71353 15.9335 8.49665V1Z"
            fill="#E64A0D"
        />
        <path
            d="M9.89476 12.2402C8.78066 13.9089 8.29361 15.9183 8.52 17.912C8.5365 18.0611 8.52138 18.2119 8.47562 18.3547C8.42987 18.4975 8.35451 18.6291 8.25447 18.7408C8.15443 18.8525 8.03195 18.9419 7.89503 19.0031C7.75812 19.0642 7.60984 19.0959 7.45987 19.0958H2.10588C1.83622 19.0957 1.57661 18.9934 1.37932 18.8096C1.18203 18.6258 1.0617 18.374 1.04255 18.105C0.769559 14.3784 1.81653 10.6746 4.00004 7.64236L9.89476 12.2402Z"
            fill="#E64A0D"
        />
        <path
            d="M12.4989 14.5902C12.131 11.752 12.0667 8.01282 12.0667 8.01282C12.0629 7.82981 12.1091 7.64923 12.2003 7.49052C12.2915 7.33181 12.4243 7.201 12.5843 7.11218C12.7444 7.02335 12.9256 6.97988 13.1086 6.98645C13.2915 6.99301 13.4692 7.04937 13.6225 7.14944C13.6225 7.14944 16.7616 9.18321 18.9748 10.9967C20.0318 11.8628 20.8764 12.7074 21.1983 13.2862C21.7812 14.3385 21.9226 15.579 21.5916 16.7354C21.2606 17.8919 20.4841 18.8697 19.4328 19.4541C18.3805 20.037 17.1399 20.1784 15.9835 19.8472C14.827 19.516 13.8494 18.7393 13.2653 17.6877C12.9443 17.1092 12.6752 15.9457 12.4989 14.5902Z"
            fill="#001965"
            stroke="white"
            stroke-width="2"
        />
    </svg>
);

export const ScoreStrong = (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="0 0 34 22" fill="none">
        <path
            d="M18.0665 8.49665V1C22.0974 1.26622 25.8773 3.05152 28.6433 5.99564L23.1699 10.6244C21.3317 9.32297 20.2155 8.79294 18.0665 8.49665Z"
            fill="#E3A11F"
        />
        <path
            d="M30 7.64236C32.1835 10.6746 33.2304 14.3784 32.9574 18.105C32.9383 18.374 32.818 18.6258 32.6207 18.8096C32.4234 18.9934 32.1638 19.0957 31.8941 19.0958H26.5401C26.3902 19.0959 26.2419 19.0642 26.105 19.0031C25.9681 18.9419 25.8456 18.8525 25.7455 18.7408C25.6455 18.6291 25.5701 18.4975 25.5244 18.3547C25.4786 18.2119 25.4635 18.0611 25.48 17.912C25.6537 14.8083 25.1693 13.8102 24.1601 12.2402L30 7.64236Z"
            fill="#B3BAD1"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9335 1C11.9026 1.26622 8.12273 3.05152 5.35667 5.99564L11.2909 10.6244C12.5839 9.45627 14.2045 8.71353 15.9335 8.49665V1Z"
            fill="#E3A11F"
        />
        <path
            d="M9.89476 12.2402C8.78066 13.9089 8.29361 15.9183 8.52 17.912C8.5365 18.0611 8.52138 18.2119 8.47562 18.3547C8.42987 18.4975 8.35451 18.6291 8.25447 18.7408C8.15443 18.8525 8.03195 18.9419 7.89503 19.0031C7.75812 19.0642 7.60984 19.0959 7.45987 19.0958H2.10588C1.83622 19.0957 1.57661 18.9934 1.37932 18.8096C1.18203 18.6258 1.0617 18.374 1.04255 18.105C0.769559 14.3784 1.81653 10.6746 4.00004 7.64236L9.89476 12.2402Z"
            fill="#E3A11F"
        />
        <path
            d="M21.8019 14.5902C22.1698 11.752 22.234 8.01282 22.234 8.01282C22.2379 7.82981 22.1917 7.64923 22.1005 7.49052C22.0093 7.33181 21.8765 7.201 21.7164 7.11218C21.5564 7.02335 21.3751 6.97988 21.1922 6.98645C21.0093 6.99301 20.8316 7.04937 20.6783 7.14944C20.6783 7.14944 17.5392 9.18321 15.326 10.9967C14.2689 11.8628 13.4244 12.7074 13.1025 13.2862C12.5196 14.3385 12.3782 15.579 12.7092 16.7354C13.0402 17.8919 13.8166 18.8697 14.868 19.4541C15.9202 20.037 17.1609 20.1784 18.3173 19.8472C19.4737 19.516 20.4514 18.7393 21.0355 17.6877C21.3565 17.1092 21.6255 15.9457 21.8019 14.5902Z"
            fill="#001965"
            stroke="white"
            stroke-width="2"
        />
    </svg>
);

export const ScoreLeading = (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="22" viewBox="0 0 34 22" fill="none">
        <path
            d="M18.0665 8.49665V1C22.0974 1.26622 25.8773 3.05152 28.6433 5.99564L23.1699 10.6244C21.3317 9.32297 20.2155 8.79294 18.0665 8.49665Z"
            fill="#098E1D"
        />
        <path
            d="M30 7.64236C32.1835 10.6746 33.2304 14.3784 32.9574 18.105C32.9383 18.374 32.818 18.6258 32.6207 18.8096C32.4234 18.9934 32.1638 19.0957 31.8941 19.0958H26.5401C26.3902 19.0959 26.2419 19.0642 26.105 19.0031C25.9681 18.9419 25.8456 18.8525 25.7455 18.7408C25.6455 18.6291 25.5701 18.4975 25.5244 18.3547C25.4786 18.2119 25.4635 18.0611 25.48 17.912C25.6537 14.8083 25.1693 13.8102 24.1601 12.2402L30 7.64236Z"
            fill="#098E1D"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9335 1C11.9026 1.26622 8.12273 3.05152 5.35667 5.99564L11.2909 10.6244C12.5839 9.45627 14.2045 8.71353 15.9335 8.49665V1Z"
            fill="#098E1D"
        />
        <path
            d="M9.89476 12.2402C8.78066 13.9089 8.29361 15.9183 8.52 17.912C8.5365 18.0611 8.52138 18.2119 8.47562 18.3547C8.42987 18.4975 8.35451 18.6291 8.25447 18.7408C8.15443 18.8525 8.03195 18.9419 7.89503 19.0031C7.75812 19.0642 7.60984 19.0959 7.45987 19.0958H2.10588C1.83622 19.0957 1.57661 18.9934 1.37932 18.8096C1.18203 18.6258 1.0617 18.374 1.04255 18.105C0.769559 14.3784 1.81653 10.6746 4.00004 7.64236L9.89476 12.2402Z"
            fill="#098E1D"
        />
        <path
            d="M20.63 19.4118C23.2238 18.2024 26.4159 16.2541 26.4159 16.2541C26.5726 16.1594 26.7003 16.0236 26.7855 15.8616C26.8707 15.6996 26.91 15.5174 26.8993 15.3347C26.8886 15.1519 26.8283 14.9756 26.7247 14.8246C26.6212 14.6736 26.4785 14.5538 26.3119 14.4779C26.3119 14.4779 22.9132 12.9161 20.1964 12.0183C18.8988 11.5896 17.7333 11.3286 17.072 11.3668C15.8713 11.4381 14.7479 11.9831 13.9486 12.8819C13.1493 13.7808 12.7394 14.9602 12.8088 16.1611C12.8801 17.3619 13.4251 18.4853 14.3242 19.2845C15.2233 20.0837 16.4028 20.4934 17.6037 20.4234C18.2641 20.3847 19.3907 19.9888 20.63 19.4118Z"
            fill="#001965"
            stroke="white"
            stroke-width="2"
        />
    </svg>
);

export const High = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9983 15.9971H8V9.38873C8 9.17404 8.29835 9 8.66639 9H11.3319C11.7 9 11.9983 9.17404 11.9983 9.38873V15.9971Z"
            fill="#098E1D"
            stroke="#098E1D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.99736 15.9988H1.99902V13.1666C1.99902 13.0746 2.29738 13 2.66541 13H5.33097C5.69901 13 5.99736 13.0746 5.99736 13.1666V15.9988Z"
            fill="#098E1D"
            stroke="#098E1D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.9983 15.995H14V4.66639C14 4.29835 14.2984 4 14.6664 4H17.3319C17.7 4 17.9983 4.29835 17.9983 4.66639V15.995Z"
            fill="#098E1D"
            stroke="#098E1D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const Pricing = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_18355_81312)">
            <path
                d="M18.1252 1.66699H5.2085C4.71135 1.66743 4.23469 1.86512 3.88316 2.21665C3.53162 2.56819 3.33394 3.04485 3.3335 3.54199V11.042C3.33394 11.5391 3.53162 12.0158 3.88316 12.3673C4.23469 12.7189 4.71135 12.9166 5.2085 12.917H18.1252C18.6223 12.9166 19.099 12.7189 19.4505 12.3673C19.802 12.0158 19.9997 11.5391 20.0002 11.042V3.54199C19.9997 3.04485 19.802 2.56819 19.4505 2.21665C19.099 1.86512 18.6223 1.66743 18.1252 1.66699ZM7.7085 5.41699H6.4585C6.29274 5.41699 6.13376 5.35114 6.01655 5.23393C5.89934 5.11672 5.8335 4.95775 5.8335 4.79199C5.8335 4.62623 5.89934 4.46726 6.01655 4.35005C6.13376 4.23284 6.29274 4.16699 6.4585 4.16699H7.7085C7.87426 4.16699 8.03323 4.23284 8.15044 4.35005C8.26765 4.46726 8.3335 4.62623 8.3335 4.79199C8.3335 4.95775 8.26765 5.11672 8.15044 5.23393C8.03323 5.35114 7.87426 5.41699 7.7085 5.41699ZM11.6668 9.79199C10.2885 9.79199 9.16683 8.67033 9.16683 7.29199C9.16683 5.91366 10.2885 4.79199 11.6668 4.79199C13.0452 4.79199 14.1668 5.91366 14.1668 7.29199C14.1668 8.67033 13.0452 9.79199 11.6668 9.79199ZM16.8752 10.417H15.6252C15.4594 10.417 15.3004 10.3511 15.1832 10.2339C15.066 10.1167 15.0002 9.95775 15.0002 9.79199C15.0002 9.62623 15.066 9.46726 15.1832 9.35005C15.3004 9.23284 15.4594 9.16699 15.6252 9.16699H16.8752C17.0409 9.16699 17.1999 9.23284 17.3171 9.35005C17.4343 9.46726 17.5002 9.62623 17.5002 9.79199C17.5002 9.95775 17.4343 10.1167 17.3171 10.2339C17.1999 10.3511 17.0409 10.417 16.8752 10.417Z"
                fill="#098E1D"
            />
            <path
                d="M16.8752 14.1666H3.95849C3.46134 14.1662 2.98468 13.9685 2.63315 13.617C2.28161 13.2654 2.08393 12.7888 2.08349 12.2916V4.98828L0.0618204 12.5249C-0.0619117 13.0051 0.00776577 13.5147 0.255866 13.944C0.503965 14.3734 0.910666 14.6882 1.38849 14.8208L14.2743 18.2716C14.5116 18.3348 14.759 18.3506 15.0023 18.3182C15.2457 18.2858 15.4803 18.2057 15.6927 18.0826C15.9052 17.9595 16.0913 17.7957 16.2404 17.6006C16.3895 17.4056 16.4987 17.1831 16.5618 16.9458L17.3285 14.1041C17.1806 14.1441 17.0283 14.1651 16.8752 14.1666Z"
                fill="#098E1D"
            />
        </g>
        <defs>
            <clipPath id="clip0_18355_81312">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const Low = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9983 15.9971H8V9.38873C8 9.17404 8.29835 9 8.66639 9H11.3319C11.7 9 11.9983 9.17404 11.9983 9.38873V15.9971Z"
            fill="#B3BAD1"
            stroke="#B3BAD1"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.99736 15.9988H1.99902V13.1666C1.99902 13.0746 2.29738 13 2.66541 13H5.33097C5.69901 13 5.99736 13.0746 5.99736 13.1666V15.9988Z"
            fill="#E80A0F"
            stroke="#E80A0F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.9983 15.995H14V4.66639C14 4.29835 14.2984 4 14.6664 4H17.3319C17.7 4 17.9983 4.29835 17.9983 4.66639V15.995Z"
            fill="#B3BAD1"
            stroke="#B3BAD1"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const NoData = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 2.5V2.5C5.8575 2.5 2.5 5.8575 2.5 10V10C2.5 14.1425 5.8575 17.5 10 17.5V17.5C14.1425 17.5 17.5 14.1425 17.5 10V10C17.5 5.8575 14.1425 2.5 10 2.5Z"
            stroke="#B3BAD1"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.3034 4.69629L4.69678 15.303L15.3034 4.69629Z"
            stroke="#B3BAD1"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const Medium = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9983 15.9971H8V9.38873C8 9.17404 8.29835 9 8.66639 9H11.3319C11.7 9 11.9983 9.17404 11.9983 9.38873V15.9971Z"
            fill="#E3A11F"
            stroke="#E3A11F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.99736 15.9988H1.99902V13.1666C1.99902 13.0746 2.29738 13 2.66541 13H5.33097C5.69901 13 5.99736 13.0746 5.99736 13.1666V15.9988Z"
            fill="#E3A11F"
            stroke="#E3A11F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.9983 15.995H14V4.66639C14 4.29835 14.2984 4 14.6664 4H17.3319C17.7 4 17.9983 4.29835 17.9983 4.66639V15.995Z"
            fill="#B3BAD1"
            stroke="#B3BAD1"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const iconButton = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M5.62305 14.5858H8.33251"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.62305 12.0848H9.16619"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.62305 9.58383H10.8336"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.2273 17.5033H4.99762C3.61634 17.5033 2.49658 16.3836 2.49658 15.0023V4.99811C2.49658 3.61682 3.61634 2.49707 4.99762 2.49707H15.0018C16.3831 2.49707 17.5028 3.61682 17.5028 4.99811V12.2286"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M17.5028 6.66586H2.49658"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.5848 14.8984V16.2056"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <circle
            cx="14.5851"
            cy="14.5855"
            r="3.75156"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.5726 12.926C14.5556 12.926 14.5418 12.9398 14.5418 12.9569C14.5418 12.9694 14.5493 12.9806 14.5608 12.9854C14.5723 12.9902 14.5856 12.9875 14.5944 12.9787C14.6032 12.9699 14.6059 12.9566 14.6011 12.9451C14.5963 12.9335 14.5851 12.926 14.5726 12.926"
            stroke="#808CB2"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

export const StarIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path
            d="M3.86556 10.4163C3.61202 10.5486 3.3053 10.5253 3.07467 10.3562C2.84403 10.1871 2.7296 9.90153 2.77961 9.61994L3.18427 7.30047L1.48057 5.66779C1.27232 5.46919 1.196 5.16899 1.28411 4.89505C1.37223 4.62111 1.60926 4.4217 1.89424 4.38175L4.25972 4.04361L5.32767 1.91323C5.45429 1.65773 5.7148 1.49609 5.99995 1.49609C6.2851 1.49609 6.5456 1.65773 6.67223 1.91323L7.74017 4.04361L10.1057 4.38175C10.3906 4.4217 10.6277 4.62111 10.7158 4.89505C10.8039 5.16899 10.7276 5.46919 10.5193 5.66779L8.81562 7.30047L9.22029 9.62044C9.27029 9.90203 9.15586 10.1876 8.92523 10.3567C8.69459 10.5258 8.38787 10.5491 8.13434 10.4168L5.99995 9.31381L3.86556 10.4163Z"
            fill="#E3A11F"
            stroke="#E3A11F"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
